// extracted by mini-css-extract-plugin
export var card = "ReviewCard-module--card--17e94";
export var heightLimit = "ReviewCard-module--height-limit--50be9";
export var imageContainer = "ReviewCard-module--image-container--6f8ab";
export var linkOutlined = "ReviewCard-module--link-outlined--b19b9";
export var quote = "ReviewCard-module--quote--59417";
export var title = "ReviewCard-module--title--bfac8";